import React from "react";
import { Box, InputAdornment, TextField } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CloseIcon from "@iconify/icons-mdi/close";
import searchIcon from "@iconify/icons-mdi/search";
import { InlineIcon } from "@iconify/react";
import { OcErrorBoundary } from "oc/components";

interface OcFilterItemSearchFormProps {
  search: string;
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClearSearch: () => void;
  disabled?: boolean;
}

export const OcFilterItemSearchForm: React.FC<OcFilterItemSearchFormProps> = ({
  search,
  onSearch,
  onClearSearch,
  disabled,
}) => {
  const theme = useTheme();

  if (disabled) return null;

  return (
    <OcErrorBoundary>
      <Box padding="16px">
        <Box
          style={{
            backgroundColor: "white",
            borderRadius: "4px",
            height: "48px",
          }}
        >
          <TextField
            label=""
            id="oc-filter-item-search-form-input"
            variant="outlined"
            fullWidth
            value={search}
            onChange={onSearch}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <InlineIcon
                    icon={searchIcon}
                    height={20}
                    color={theme.palette.gray60.main}
                  />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <InlineIcon
                    icon={CloseIcon}
                    onClick={onClearSearch}
                    style={{ cursor: "pointer" }}
                  />
                </InputAdornment>
              ),
              style: {
                height: "48px",
              },
            }}
          />
        </Box>
      </Box>
    </OcErrorBoundary>
  );
};

export default OcFilterItemSearchForm;
